<template>
    <div>
      <range-manip :params="rangeManpiOpts" @forCommit="getData"></range-manip>
    </div>
</template>

<script>
  import rangeManip from '@/components/byl/rangeManip/withInputs.vue'
  import msgService from '@/utils/sendMsg'
  export default {
      components: { rangeManip },
      data () {
        return {
          rangeManpiOpts: {
            name: 'range',
            outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
            editMode: true
          }
        }
      },
      methods: {
        getData (val) {
          var that = this
          if (val.form && val.form.title && val.form.content && val.form.type && val.form.type.length > 0 && val.people && val.people.length > 0) {
            msgService.sendMsg(val).then((r) => {
              that.$toasted.show('消息已发送')
              val.form = {
                title: '',
                content: '',
                type: []
              }
              val.people = []
            })
          }
        }
      }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/msg/model.vue